import $ from 'jquery';
import throttle from 'lodash.throttle';

const JS_PREFIX = 'js-top-bar';
const JS_NAV_PREFIX = 'js-nav';

export default {
  _settings: {
    scrollThrottle: 30,
    scrollLimit: 10
  },
  _dom: {
    $topBar: null,
    $topBarBackground: null,
    $scrollElements: null,
    $menuToggle: null,
    $nav: null
  },
  _scrollingTimeout: null,
  set settings(options) {
    if(!options) {
      return;
    }

    if(typeof options !== 'object') {
      throw Error('top-bar: options has to be an object');
    }

    for(let key in this._settings) {
      if(Object.prototype.hasOwnProperty.call(options, key)) {
        this._settings[key] = options[key]
      }
    }
  },
  get settings() {
    return this._settings;
  },
  set $topBar(selector) {
    this._dom.$topBar = $(`#${selector}`);
  },
  get $topBar() {
    return this._dom.$topBar;
  },
  set $nav(selector) {
    this._dom.$nav = $(`#${selector}`);
  },
  get $nav() {
    return this._dom.$nav;
  },
  set $scrollElements(selector) {
    this._dom.$scrollElements = this._dom.$topBar.find(`.${selector}`);
  },
  get $scrollElements() {
    return this._dom.$scrollElements;
  },
  set $menuToggle(selector) {
    this._dom.$menuToggle = this._dom.$topBar.find(`.${selector}`);
  },
  get $menuToggle() {
    return this._dom.$menuToggle;
  },
  toggleClasses(scrollY) {
    if(scrollY >= this.settings.scrollLimit) {
      if(!this.$topBar.hasClass('has-scrolled')) {
        this.$topBar.addClass('has-scrolled');
        this.$scrollElements.addClass('has-scrolled');
      }
    } else {
      if(this.$topBar.hasClass('has-scrolled')) {
        this.$topBar.removeClass('has-scrolled');
        this.$scrollElements.removeClass('has-scrolled')
      }
    }
  },
  enableMenuToggle() {
    const self = this;

    this.$menuToggle = `${JS_PREFIX}__menu-toggle`;
    this.$nav = JS_NAV_PREFIX;
    this.$body = $('body');

    this.$menuToggle.on('click', () => {
      if(self.$topBar.hasClass('has-toggled-menu')) {
        self.$topBar.removeClass('has-toggled-menu');
        self.$nav.removeClass('has-toggled-menu');
        self.$body.removeClass('top-bar--has-toggled-menu');
      } else {
        self.$topBar.addClass('has-toggled-menu');
        self.$nav.addClass('has-toggled-menu');
        self.$body.addClass('top-bar--has-toggled-menu');
      }
    });
  },
  addScrollListener() {
    $(window).on('scroll', throttle(() => {
      this.toggleClasses(window.pageYOffset);
    }, this.settings.scrollThrottle));
  },
  init (options) {
    this.settings = options;

    this.$topBar = JS_PREFIX;
    this.$scrollElements = JS_PREFIX + '__scroll-element';

    if(!this.$topBar.length) {
      return;
    }

    // Disable background scrolling on ios.. hopefully
    this.$topBar.on('touchmove', (e) => {
      e.stopPropagation();
    });

    this.addScrollListener();
    this.enableMenuToggle();
  }
}
